import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-keyword",
  "use": "icon-keyword-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-keyword\"><defs><style type=\"text/css\"></style></defs><path d=\"M622.933333 708.266667l196.266667-196.266667-196.266667-196.266667L682.666667 256l256 256-256 256-59.733334-59.733333m-221.866666 0L204.8 512l196.266667-196.266667L341.333333 256l-256 256 256 256 59.733334-59.733333z\" fill=\"\" p-id=\"18969\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol